import { CommonModuleInner, SectionSubtitle, SectionTitle } from '@/sem/styles';
import { useIsMobile } from '~/context/common/DeviceContext';
import type { SemPopularModelsModule } from '~/contracts/sem';
import SemImageSource from '~/contracts/sem/SemImageSource';
import {
  GridWrapper,
  PopularModelsCard,
  CardTitle,
  ImgWrapper
} from './PopularModels.styles';
import SemTrackWrapper from '../SemTrackWrapper';

type OwnProps = Omit<SemPopularModelsModule, '__typename'>;

const getImageUrl = (image: SemImageSource, isMobile: boolean): string =>
  (isMobile ? image?.mobile : image?.desktop) ?? image?.mobile ?? '';

function PopularModels({ id, subtitle, title, items }: OwnProps) {
  const isMobile = useIsMobile();

  return id && items ? (
    <SemTrackWrapper sectionName="Popular Models">
      <CommonModuleInner>
        <div className="flex flex-col gap-8 self-start">
          {title && <SectionTitle>{title}</SectionTitle>}
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </div>
        <GridWrapper>
          {items.filter(Boolean).map(item =>
            item?.slug ? (
              <a
                href={item.slug}
                key={item.title}
                className="inline-block !w-full no-underline"
                data-analytics-id="Popular Models - Model Item"
                data-analytics-attributes={JSON.stringify({
                  title: item.title,
                  linkUrl: item.slug
                })}
              >
                <PopularModelsCard>
                  <CardTitle>{item.title}</CardTitle>
                  {item.latestAvailableStockImage && (
                    <ImgWrapper>
                      <picture>
                        <source
                          srcSet={getImageUrl(
                            item.latestAvailableStockImage,
                            isMobile
                          )}
                          media="(min-width: 1440px)"
                        />
                        <img
                          className="h-full w-full"
                          src={getImageUrl(
                            item.latestAvailableStockImage,
                            isMobile
                          )}
                          alt={item.title ?? 'Popular Model'}
                        />
                      </picture>
                    </ImgWrapper>
                  )}
                </PopularModelsCard>
              </a>
            ) : null
          )}
        </GridWrapper>
      </CommonModuleInner>
    </SemTrackWrapper>
  ) : null;
}

export default PopularModels;
